import {Component, Input, OnInit} from '@angular/core';
import {FieldType} from "@ngx-formly/core";

@Component({
  selector: 'formly-radio-field',
  template: `
    <ds-radiogroup
      label="German Resident"
      [formControl]="formControl"
      [formlyAttributes]="field"
      options="{{to.radioOptions | json}}"
    ></ds-radiogroup>
  `,
  styles: [],
})
export class FormlyRadioFieldComponent extends FieldType implements OnInit {

  @Input() helpertext: string;
  @Input() label: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() required?: boolean;
  @Input() opt = [];

  ngOnInit(): void {
    this.label = this.to.label;
    this.placeholder = this.to.placeholder;
    this.helpertext = this.to.helpertext;
    this.required = this.to.required;
    this.name = this.key.toString();
  }
}
